import { useContext, useEffect, useState } from "react";
import { Button, Form, Tab, Tabs } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../../context";
import { useForm } from "react-hook-form";
import PulseOpacitySpinner from "../../components/MuniSpinner/PulseOpacitySpinner";
import HelperText from "../../components/HelperText";
import { Table } from "../../components";
import { formatRangeString } from "../Recibos/handlers";
import TextInput from "../../components/ReactHookForm/TextInput";
import { getHistorialActasInspector, getReporteInspectores, historialInspectorTableData, historialInspectoresTableData } from "./handlers";
import { renderModal } from "../handlers";
import MapIcon from "@mui/icons-material/Map";
import BusquedaMapaCalor from "./BusquedaMapaCalor";
import MuniSpinner from "../../components/MuniSpinner";

const HistorialInspectores = () => {
  const { actions: ua } = useContext(UserContext);
  const navigate = useNavigate();
  const [reporteInspectores, setReporteInspectores] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (ua.hasRole("sudo")) {
      getReporteInspectores(setReporteInspectores, setIsLoading);
    } else {
      navigate("/");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className='d-flex gap-4 align-items-center mb-4'>
        <h3 className='mb-0'>Historial Inspectores</h3>
        <Link to='/' className='my-auto  ms-auto me-1 btn btn-primary' style={{ maxHeight: "38px" }}>
          <span>Volver</span>
        </Link>
      </div>
      {isLoading ? (
        <MuniSpinner />
      ) : (
        reporteInspectores && (
          <div>
            <div>
              <Table
                data={historialInspectoresTableData(reporteInspectores, setSelectedRow, setModalIsOpen)}
                name='historial_actas_inspectores'
                /*                 render={() => (
                  <Button className='my-auto me-1 btn btn-primary' style={{ height: "38px" }} onClick={() => setModalIsOpen(true)}>
                    Mapa de calor por inspector <MapIcon />
                  </Button>
                )} */
              />
            </div>
            {modalIsOpen && renderModal(modalIsOpen, setModalIsOpen, `Actas cargadas por ${selectedRow.nombre}`, <BusquedaMapaCalor selectedRow={selectedRow} />, "lg")}
          </div>
        )
      )}
    </div>
  );
};

export default HistorialInspectores;
